import { format, isValid, parseISO } from 'date-fns';

/** Presets for every user-visible date/time in the app. */
export type AppDateTimeFormatKind = 'full' | 'date' | 'time';

const PATTERNS: Record<AppDateTimeFormatKind, string> = {
  /** Short weekday, full calendar date, 12-hour clock with seconds (e.g. Wed, June 3, 2026 at 2:30:45 PM). */
  full: "EEE, MMMM d, yyyy 'at' h:mm:ss a",
  /** Short weekday and full calendar date without time. */
  date: 'EEE, MMMM d, yyyy',
  /** 12-hour clock with seconds only. */
  time: 'h:mm:ss a',
};

export function parseAppDateTime(
  value: string | Date | null | undefined,
): Date | null {
  if (value == null) {
    return null;
  }
  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }
  const raw = value.trim();
  if (!raw) {
    return null;
  }
  const parsed = parseISO(raw);
  return isValid(parsed) ? parsed : null;
}

export function formatAppDateTime(
  value: string | Date | null | undefined,
  kind: AppDateTimeFormatKind = 'full',
): string {
  if (value instanceof Date) {
    return isValid(value) ? format(value, PATTERNS[kind]) : '';
  }
  const raw = (value ?? '').trim();
  if (!raw) {
    return '';
  }
  const d = parseAppDateTime(raw);
  if (!d) {
    return raw;
  }
  return format(d, PATTERNS[kind]);
}
